import { connect } from 'react-redux';
import SpotModalComponent from '../components/SpotModalComponent';
import { setSpotModalOpen, getSpotDataIfNeeded } from '../actions/spotActions';
// import {
//    playMediaFromSourceWithMeta, pauseMediaPlayer, playMediaPlayer,
// } from '../../aovivoBar/actions/MediaPlayerActions';

const mapStateToProps = (state) => ({
    spotModalOpen: state.spot.spotModalOpen,
    spotSlug: state.spot.spotSlug,
    spotData: state.spot.spotData,
    isLoadingSpotData: state.spot.isLoadingSpotData,
    // currentSources: state.getIn(['aovivoBar', 'MediaPlayer', 'currentSources']),
    // playerStatus: state.getIn(['aovivoBar', 'MediaPlayer', 'playerStatus']),
});
const mapDispatchToProps = (dispatch) => ({
    setSpotModalOpen: (spotModalOpen) => {
        dispatch(setSpotModalOpen(spotModalOpen));
    },
    getSpotDataIfNeeded: (spotId) => {
        dispatch(getSpotDataIfNeeded(spotId));
    },
    /*
    playMediaFromSourceWithMeta: (source, meta) => {
        dispatch(playMediaFromSourceWithMeta(source, meta));
    },
    pauseMediaPlayer: () => {
        dispatch(pauseMediaPlayer());
    },
    playMediaPlayer: () => {
        dispatch(playMediaPlayer());
    },
    */
});
const SpotModalContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(SpotModalComponent);

export default SpotModalContainer;
